import {
  ComponentStyleProps,
  componentStylePropsOf,
} from "../../../../lib/styles/props/component-style-props";
import {
  Checkbox,
  CheckboxGroup,
  ComponentMultiStyleConfig,
  Text,
  useMultiStyleConfig,
  VStack,
} from "@chakra-ui/react";
import React, { useMemo } from "react";
import { CheckboxContent } from "../../../control";
import { messageId, ValueObjectMetaEnum } from "../../../../lib";
import { useMessageDictionary } from "../../../../hooks/use-message-dictionary";
import { hasValue } from "../../../../lib/util/common-util";
import { CMFrameButtonPopupSearchCondition } from "../CMFrameButtonPopupSearchCondition/CMFrameButtonPopupSearchCondition";

export type CMButtonPopupSearchConditionCheckboxProps<
  T extends [string, ...string[]],
> = {
  /**
   * 値。
   */
  values: T[number][] | null;

  labelSubmit?: string;
  labelClear?: string;

  /**
   * クリアボタンの表示制御 trueの場合にクリアボタン非表示
   */
  hideClearButton?: boolean;

  /**
   * 値オブジェクトメタデータ
   */
  valueObjectMeta: ValueObjectMetaEnum<T>;

  internalValues: T[number][];
  /**
   * チェックボックスで選択された値を呼び出し元に返却
   */
  onChangeInternalValues: (values: T[number][]) => void;

  onSubmit: () => void;
  onClear: () => void;
} & ComponentStyleProps;

/**
 * チェックボックス検索条件のコンポーネント.
 *
 */
export const CMButtonPopupSearchConditionCheckbox = <
  T extends [string, ...string[]],
>({
  values,
  labelSubmit = "",
  labelClear = "",
  hideClearButton = false,

  valueObjectMeta,

  internalValues,
  onChangeInternalValues,

  onSubmit,
  onClear,

  sx,
  ...rest
}: CMButtonPopupSearchConditionCheckboxProps<T>) => {
  const styles = useMultiStyleConfig(
    "CMButtonPopupSearchConditionCheckboxStyles",
    {},
  );
  const dict = useMessageDictionary();

  /**
   * チェックボックスの入力値を取得し、保持。
   */
  const handleChangeInternalValues = (changedValues: (string | number)[]) => {
    const _changedValues = changedValues
      .map((v) => valueObjectMeta.toDomainObjectOrNull(v.toString()))
      .filter(hasValue);

    onChangeInternalValues(_changedValues);
  };

  // const [internalValues, setInternalValues] = useState<T[number][]>(
  //   values ?? [],
  // );
  // useEffect(() => {
  //   setInternalValues(values ?? []);
  // }, [values]);

  // metaデータから取得した値をcontentの形に変換する
  const content: CheckboxContent = useMemo(
    () => ({
      options: valueObjectMeta.values.map((v) => ({
        label: dict(messageId(valueObjectMeta.dict[v])) ?? "",
        value: v,
      })),
    }),
    [valueObjectMeta, dict],
  );

  // /**
  //  * Submitボタン押下時、呼び出し元に選択値を返却する。
  //  * （ただし空の場合は代わりにnullを返却する。）
  //  */
  // const handleSubmit = useCallback(() => {
  //   if (internalValues.length <= 0) onChange?.(null);
  //   else {
  //     // 次の処理で、正しい順序に並べ替える。
  //     const sortedValues = valueObjectMeta.values.filter((v) =>
  //       internalValues.includes(v),
  //     );
  //     onChange?.(sortedValues);
  //   }
  // }, [onChange, internalValues, valueObjectMeta]);
  //
  // /**
  //  * Clearボタン押下時、内部値には空配列を設定し、呼び出し元にはnullを返却する。
  //  */
  // const handleClear = useCallback(() => {
  //   setInternalValues([]);
  //   onChange?.(null);
  // }, [onChange]);
  //
  // /**
  //  * チェックボックスの入力値を取得し、保持。
  //  * @param changedValues 選択値
  //  */
  // const handleChange = (changedValues: (string | number)[]) => {
  //   const _changedValues = changedValues
  //     .map((v) => {
  //       const validated = valueObjectMeta.validate(v.toString());
  //       if (validated.state !== "ok") return null;
  //       return validated.value;
  //     })
  //     .filter(hasValue);
  //
  //   setInternalValues(_changedValues);
  // };

  return (
    <CMFrameButtonPopupSearchCondition
      labelSubmit={labelSubmit}
      labelClear={labelClear}
      hideClearButton={hideClearButton}
      onSubmit={onSubmit}
      onClear={onClear}
      {...rest}
      sx={{ ...styles.container, ...sx }}
    >
      <CheckboxGroup
        defaultValue={values ?? undefined}
        value={internalValues}
        onChange={handleChangeInternalValues}
      >
        <VStack sx={styles.checkboxStack}>
          {content.options.map((option, index) => (
            <Checkbox key={index} value={option.value} sx={styles.checkbox}>
              <Text sx={styles.checkboxLabel}>{option.label}</Text>
            </Checkbox>
          ))}
        </VStack>
      </CheckboxGroup>
    </CMFrameButtonPopupSearchCondition>
  );
};

export const CMButtonPopupSearchConditionCheckboxStyles: ComponentMultiStyleConfig =
  {
    parts: ["container", "checkboxStack", "checkbox", "checkboxLabel"],
    baseStyle: {
      container: {},
      checkboxStack: {
        alignItems: "flex-start",
      },
      checkbox: {
        mt: 0,
      },
      checkboxLabel: {},
    },
  };
